import { useCallback } from "react";

import { useLocation, useNavigate } from "react-router-dom";

/**
 * Returns a function that edits the live URL search params in place and
 * `navigate`s with `replace`, preserving the pathname and every untouched
 * param. A single shared write idiom so independent param owners (table state,
 * data-source flags) compose by only ever touching their own keys.
 */
export function useReplaceSearchParams(): (
    mutate: (params: URLSearchParams) => void
) => void {
    const { pathname, search } = useLocation();
    const navigate = useNavigate();

    return useCallback(
        (mutate) => {
            const params = new URLSearchParams(search);
            mutate(params);
            const query = params.toString();
            navigate(query ? `${pathname}?${query}` : pathname, {
                replace: true,
            });
        },
        [pathname, search, navigate]
    );
}
